import styled from 'styled-components';
import Icon from '../../assets/images/sign-icon.svg';

const SignIcon = styled.span`
  background: url(\"${Icon}\") no-repeat left center;
  background-size: 36px 38px;
  display: inline-block;
  position: relative;
  width: 36px;
  height: 38px;
`;

export default SignIcon;
